// если добавлять иконку короны, то надо на все разрешения указывать
export const defaultSizes = {
  about: {
    mobile: { width: 275, height: 46 },
  },
  advice: {
    tablet: { width: 594, height: 61 },
  },
  download: {
    tablet: { width: 378, height: 85 },
    mobile: { width: 331, height: 69 },
  },
  prizes: {
    tablet: { width: 778, height: 133 },
  },
  rules: {
    tablet: { width: 334, height: 70 },
    mobile: { width: 221, height: 46 },
  },
  top: {
    desktop: { width: 518, height: 128 },
    tablet: { width: 389, height: 97 },
    mobile: { width: 259, height: 61 },
  },
  votes: {
    tablet: { width: 700, height: 64 },
  },
};
